export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7113.8e7a80cf.jpg";